var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "wine-details-container" }, [
    _vm.hasDetails
      ? _c("div", { staticClass: "wine-details-list" }, [
          _vm.tastingNotes.length > 0 || _vm.hasTastingNoteFiles
            ? _c(
                "div",
                { staticClass: "wine-details-list-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "heading",
                      class: { expanded: _vm.showContent.tastingNotes },
                      on: {
                        click: function ($event) {
                          return _vm.toggleContent("tastingNotes")
                        },
                      },
                    },
                    [
                      _c("WineProductSvgIcons", {
                        staticClass: "category-icon",
                        attrs: { name: "TastingNotesIcon" },
                      }),
                      _vm._v(" "),
                      _c("h3", [_vm._v("Tasting Notes")]),
                      _vm._v(" "),
                      _c("WineProductSvgIcons", {
                        staticClass: "accordion-icon",
                        attrs: { name: "ChevronIcon" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition-group",
                    { attrs: { name: "slide-fade" } },
                    [
                      _vm.showContent.tastingNotes || _vm.hasTastingNoteFiles
                        ? [
                            _vm.showContent.tastingNotes
                              ? _c(
                                  "ul",
                                  {
                                    key: "tasting-notes-1",
                                    staticClass: "tasting-notes-list",
                                  },
                                  _vm._l(
                                    _vm.tastingNotesDisplay,
                                    function (note, index) {
                                      return _c(
                                        "li",
                                        {
                                          key: index,
                                          staticClass: "tasting-note",
                                        },
                                        [
                                          _c("h4", { staticClass: "label" }, [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(note.title) +
                                                "\n              "
                                            ),
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "description" },
                                            [
                                              _vm._v(
                                                "\n                " +
                                                  _vm._s(note.text) +
                                                  "\n              "
                                              ),
                                            ]
                                          ),
                                        ]
                                      )
                                    }
                                  ),
                                  0
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasTastingNoteFiles &&
                            _vm.showContent.tastingNotes
                              ? _vm._l(
                                  _vm.previousTastingNotes,
                                  function (file, index) {
                                    return _c(
                                      "div",
                                      {
                                        key: index,
                                        staticClass: "previous-tasting-notes",
                                      },
                                      [
                                        _c(
                                          "div",
                                          { staticClass: "file-container" },
                                          [
                                            _c(
                                              "router-link",
                                              {
                                                attrs: {
                                                  to: "",
                                                  href: _vm
                                                    .previousTastingNotesFiles[
                                                    index
                                                  ],
                                                  title:
                                                    _vm.prevNotesTitle(file),
                                                  target: "_blank",
                                                },
                                              },
                                              [
                                                _c("WineProductSvgIcons", {
                                                  staticClass: "category-icon",
                                                  attrs: {
                                                    name: "PreviousNotesIcon",
                                                  },
                                                }),
                                                _vm._v(" "),
                                                _c(
                                                  "div",
                                                  { staticClass: "title" },
                                                  [
                                                    _vm.dataTitle(file)
                                                      ? [
                                                          _vm._v(
                                                            "\n                      " +
                                                              _vm._s(
                                                                _vm.dataTitle(
                                                                  file
                                                                )
                                                              ) +
                                                              "\n                    "
                                                          ),
                                                        ]
                                                      : [
                                                          _vm._v(
                                                            "\n                      Download Tasting Notes\n                    "
                                                          ),
                                                        ],
                                                  ],
                                                  2
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ]
                                    )
                                  }
                                )
                              : _vm._e(),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.wineMaking.length > 0
            ? _c(
                "div",
                { staticClass: "wine-details-list-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "heading",
                      class: { expanded: _vm.showContent.wineMaking },
                      on: {
                        click: function ($event) {
                          return _vm.toggleContent("wineMaking")
                        },
                      },
                    },
                    [
                      _c("WineProductSvgIcons", {
                        staticClass: "category-icon",
                        attrs: { name: "WineMakingIcon" },
                      }),
                      _vm._v(" "),
                      _c("h3", [_vm._v("Notes")]),
                      _vm._v(" "),
                      _c("WineProductSvgIcons", {
                        staticClass: "accordion-icon",
                        attrs: { name: "ChevronIcon" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade" } },
                    [
                      _vm.showContent.wineMaking
                        ? [
                            _c(
                              "ul",
                              { staticClass: "tasting-notes-list" },
                              _vm._l(
                                _vm.wineMakingDisplay,
                                function (note, index) {
                                  return _c(
                                    "li",
                                    {
                                      key: `wm-${index}`,
                                      staticClass: "tasting-note",
                                    },
                                    [
                                      _c("h4", { staticClass: "label" }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(note.title) +
                                            "\n              "
                                        ),
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "description" },
                                        [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(note.text) +
                                              "\n              "
                                          ),
                                        ]
                                      ),
                                    ]
                                  )
                                }
                              ),
                              0
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.technicalNotes.length > 0 || _vm.features.length > 0
            ? _c(
                "div",
                { staticClass: "wine-details-list-item" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "heading",
                      class: { expanded: _vm.showContent.technical },
                      on: {
                        click: function ($event) {
                          return _vm.toggleContent("technical")
                        },
                      },
                    },
                    [
                      _c("WineProductSvgIcons", {
                        staticClass: "category-icon",
                        attrs: { name: "TecnicalNotesIcon" },
                      }),
                      _vm._v(" "),
                      _c("h3", [_vm._v("Technical")]),
                      _vm._v(" "),
                      _c("WineProductSvgIcons", {
                        staticClass: "accordion-icon",
                        attrs: { name: "ChevronIcon" },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "transition",
                    { attrs: { name: "slide-fade" } },
                    [
                      _vm.showContent.technical
                        ? [
                            _c(
                              "ul",
                              { staticClass: "tasting-notes-list grid" },
                              [
                                _vm._l(
                                  _vm.technicalNotesDisplay,
                                  function (note, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: `tn-${index}`,
                                        staticClass: "tasting-note",
                                      },
                                      [
                                        _c("h4", { staticClass: "label" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(note.title) +
                                              "\n              "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "description" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(note.text) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                                _vm._v(" "),
                                _vm._l(
                                  _vm.featuresDisplay,
                                  function (feature, index) {
                                    return _c(
                                      "li",
                                      {
                                        key: `f-${index}`,
                                        staticClass: "tasting-note",
                                      },
                                      [
                                        _c("h4", { staticClass: "label" }, [
                                          _vm._v(
                                            "\n                " +
                                              _vm._s(feature.title) +
                                              "\n              "
                                          ),
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          { staticClass: "description" },
                                          [
                                            _vm._v(
                                              "\n                " +
                                                _vm._s(feature.text) +
                                                "\n              "
                                            ),
                                          ]
                                        ),
                                      ]
                                    )
                                  }
                                ),
                              ],
                              2
                            ),
                          ]
                        : _vm._e(),
                    ],
                    2
                  ),
                ],
                1
              )
            : _vm._e(),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }